<template>
  <div class="form-item-head">
    <div class="title-container">
      <span class="required-icon" v-if="required">*</span>
      <span>{{title}}<i v-if="required">（必填）</i></span>
    </div>
    <p class="desc" v-if="desc">{{desc}}</p>
  </div>
</template>

<script>
export default {
  name: 'form-title',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.form-item-head {
  .title-container {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 16px;
    color: #303030;
    line-height: 24px;

    & .required-icon {
      flex: none;
      margin-top: 3px;
      margin-right: 6px;
      height: 21px;
      color: #F74C3A;
    }
    & i {
      font-weight: normal;
      color: #828A92;
      opacity: .6;
    }
  }

  .desc {
    margin-bottom: 14px;
    line-height: 14px;
    font-size: 14px; color: #828A92;
  }
}

</style>
